// Angular
import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
// other
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'cv-custom-p-table-comp-grid-cell-image',
    templateUrl: './custom-p-table-comp-grid-cell-image.component.html',
    styleUrls: ['./custom-p-table-comp-grid-cell-image.component.scss']
})
export class CustomPTableCompGridCellImageComponent implements OnInit, OnDestroy {
    @Input() value: string;
    public noImage: string;
    public src: string;
    public isImageAvailable: boolean;

    constructor(private modalService: NgbModal, private eleRef: ElementRef) {
        this.noImage = 'assets/img/placeholder/No-file-asset.png';
        this.src = '';
        this.isImageAvailable = false;
    }

    ngOnInit(): void {
        if (this.value.length > 0 && this.value !== 'N/A' ) {
            this.src = this.value;
            this.isImageAvailable = true;
        }
    }

    ngOnDestroy(): void {
        this.modalService.dismissAll();
    }

    /**
     * Open the image modal
     * @param content
     */
    open(content: any): void {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }
}
